import PropTypes from 'prop-types';

function Error(props) {
  return <p className='text-center'>{props.content}</p>;
}

Error.defaultProps = {
  content: 'خطایی رخ داده است.'
};

Error.propTypes = {
  content: PropTypes.string.isRequired
};

export default Error;
